import React, { useState } from "react";

import { useNavigate, useLocation } from "react-router-dom";

// @mui/material components

import CircularProgress from '@mui/material/CircularProgress';

// @mui/icons-material
import People from "@mui/icons-material/People";
import Search from "@mui/icons-material/Search";

// core components
import OthelloGrid from '../componentsothello/OthelloGrid.jsx';
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

import { DataStatePage, OpcionSiNoChar, TipoOthelloFieldGrid, PopUpResult, Roles } from "../othelloConstantes.jsx";
import OthelloBotonera from '../componentsothello/OthelloBotonera.jsx';
import OthelloPopUpResult from "../componentsothello/OthelloPopUpResult.jsx";
import OthelloEdit  from '../componentsothello/OthelloEdit.jsx';
import Button from "../components/Button.jsx";
import OthelloTituloPanelData from "../componentsothello/OthelloTituloPanelData.jsx";

export default function Usuarios({ ...props }) {
    const { literal, idRol, tipooficina } = props;

    const [loading, setLoading] = React.useState(true);

    const [statePage, setstatePage] = React.useState(DataStatePage.dsSearch);
    const [datausuarios, setdatausuarios] = React.useState(null);

    const [alert, setalert] = React.useState(null);


    const navigate = useNavigate();

    const location = useLocation();

    React.useEffect(() => {

        setLoading(false);
        getDataPage();
    }, [loading]);


    //METODOS GLOBALES DE LA PAGINA

    const getDataPage = () => {
        //Si es supeusuario entonce busco los usuarios
        if (idRol == Roles.SuperUsuario) {
            fetch('api/Data/GetUsuarios')
                .then(response => response.json())
                .then(data => {
                    setdatausuarios(data)
                });
        }
        //Sino, es que es administrador, y por tanto, solo tendra acceso al meter codigo de cliente
        else {
            setdatausuarios([]);
        }
    }

    //METODO SOBRE EL GRID 

    const editGridDataPage = (valor, index) => {

        if (valor != null) {
            navigate('/admin/profile/?id=' + valor.id_Usuario);
            //navigate('/admin/almacen/albaranes', { state: valor });
            //props.history.push('/admin/profile/?id=' + valor.id_Usuario);
            //window.location.assign('/admin/profile/?id=' + valor.id_Usuario);
        }
    }

    const nuevoDataPage = () => {
        navigate('/admin/profile/?id=-1');
        //props.history.push('/admin/profile/?id=-1');
    }

    const deleteGridDataPage = (valor, index) =>
    {
        if (valor != null) {
            var jsonData = JSON.stringify(valor.id_Usuario);

            fetch('api/Data/EliminarUsuario', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: jsonData

            }).then(response => response.json()).then(res => {

                if (res) {
                    if (datausuarios != null) {
                        var array = [...datausuarios]; // make a separate copy of the array

                        //Elimino el de index concreto
                        array.splice(index, 1);

                        setdatausuarios(array);
                        setalert(PopUpResult.OK);
                    }
                }
            }).catch(error => {
                setalert(PopUpResult.KO);
            });
        }
    }

    const buscarBoton = () =>
    {       
        //Obtengo los datos
        let formulario = document.getElementById('formbusqcodigo');
        let formData = new FormData(formulario);
        //const data = new FormData(refs.form);

        fetch('api/Data/BuscarUsuarios', {
            method: 'POST',
            body: formData,

        }).then(response => response.json()).then(data => {

            setdatausuarios(data)

            //setState({ datausuarios: data, loading: false });

        }).catch(error => {
            setdatausuarios([])
            //setState({ datausuarios: [], loading: false });
        });
    }

    const onClosePopUpResult = () => {
        setalert(null);
    }

    function renderFormUsuarios( datos) {
        //Generamos los valores de cada una de las lineas de grid
        let cabeceros = ["Nombre", "Apellidos", "DNI/CIF", , "E-Mail", "Telefono", "Codigo", "Confirmado"];

        let valoreshow = ["nombre", "Apellido", "NIF_CIF", , "eMail", "telefono", "codigoCliente", "confirmado"];

        let datasourceFields = [];
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloComboBox, fieldname: "confirmado", items: OpcionSiNoChar });

        //Creamos el grid global 
        return (<OthelloGrid datacabeceros={cabeceros} datashow={valoreshow} datasource={datos} datasourcefields={datasourceFields} onEdit={editGridDataPage} onDelete={idRol == Roles.SuperUsuario ? deleteGridDataPage : null} permitefiltrar={true} verpaginaciontop={false} verpaginacionbottom={true} tamanopagina={15} />);

    }

    let formulario = loading ? <p><CircularProgress color="secondary" /></p> : renderFormUsuarios(datausuarios);

    let alerta = alert != null ? <OthelloPopUpResult titulo="" alert={alert} onClosePopUpResult={onClosePopUpResult} /> : "";

    return (
        <Grid container>
            <Grid item xs={12} sm={12} md={12}>
                {alerta}
            </Grid>
            {idRol == Roles.SuperUsuario || idRol == Roles.Administrador ?
                <Grid container>
                    <Grid item xs={12} >
                        <OthelloBotonera statePage={statePage} onNuevo={nuevoDataPage} forzarnuevo={true} />
                        <form id="formbusqcodigo" >
                            <Grid container xs={12} >
                                <Grid item xs={12} sm={3}>
                                    <OthelloEdit label="Codigo" fieldname="codigo" />
                                </Grid>
                                <Grid item xs={12} sm={1}>
                                    <Button color="info" size="sm" onClick={buscarBoton}><Search />Buscar</Button>
                                </Grid>
                            </Grid>
                        </form>
                    </Grid>
                </Grid>
                : ""}
            <Grid item xs={12} sm={12} md={12}>
                <OthelloTituloPanelData tituloliteral="_usuarios" margentop={0}>
                    <Grid container>
                        <Grid item xs={12}>
                            {formulario}
                        </Grid>
                    </Grid>
                </OthelloTituloPanelData>
            </Grid>            
        </Grid>
    );
}
